import { is } from '../util/is';

/**
 * A data structure that can be empty.
 */
type Emptiable = unknown[] | Record<string, unknown> | string;

/**
 * Takes a value and returns `true` if the value is empty, otherwise `false`.
 *
 * ```ts
 * tt.isEmpty({});
 * // => true
 *
 * tt.isEmpty([]);
 * // => true
 *
 * tt.isEmpty('');
 * // => true
 * ```
 */
export function isEmpty(v: Emptiable): boolean {
  if (is(Array, v)) {
    return (v as unknown[] | string).length === 0;
  } else {
    if (v != null) {
      for (const k in v as Record<string, any>) {
        if (Object.prototype.hasOwnProperty.call(v, k)) {
          return false;
        }
      }
    }

    return true;
  }
}
